import React from 'react'
import Navbar from '../Components/Navbar/Navbar'
import Classes from '../Components/Classes/Classes'
import Footer from '../Components/Footer/Footer'

const ClassesPage = () => {
  return (
    <div>
      <Navbar/>
      <Classes/>
      <Footer/>
    </div>
  )
}

export default ClassesPage
